import { UserTablePage } from "~/domain/common";
import { LqsNavigation } from "~/lqs";

export function LqsUserTablePage() {
  return <UserTablePage navigation={<LqsNavigation />} />;
}
